import React from "react";
import "./colors.css";
import "./text.css";
import "./Components.css";

function Button({ buttonname, onClick }) {
  return (
    <button 
      className="button smalltext" 
      onClick={onClick}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 20px",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        backgroundColor:"#14B88F"
      }}
    >
      <p className="button">{buttonname}</p>
    </button>
  );
}

export default Button;
